export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_55-fa0e4ae8a385626c48408da5cfcc268b.jpg";